// src/pages/HomePage.jsx
import React, { useMemo, useState } from 'react';
import { Box, Container, Typography, TextField, Grid, Paper } from '@mui/material';

import DashboardQuick from '../components/DashboardQuick';

const toLocalISO = (d) => {
  const tz = d.getTimezoneOffset();
  return new Date(d.getTime() - tz * 60000).toISOString().slice(0,10);
};

export default function HomePage() {
  // rango por defecto: últimos 7 días [hoy-6, mañana)
  const today = useMemo(() => new Date(), []);
  const sevenDaysAgoISO = useMemo(() => {
    const d = new Date(today); d.setDate(d.getDate() - 6);
    return toLocalISO(d);
  }, [today]);
  const tomorrowISO = useMemo(() => {
    const d = new Date(today); d.setDate(d.getDate() + 1);
    return toLocalISO(d);
  }, [today]);

  const [desde, setDesde]   = useState(sevenDaysAgoISO);
  const [hasta, setHasta]   = useState(tomorrowISO); // exclusivo
  const [renaes, setRenaes] = useState('');
  const [idUps, setIdUps]   = useState('');

  return (
    <Container maxWidth="xl" sx={{ py: 2 }}>
      <Box sx={{ mb: 1 }}>
        <Typography variant="h5" sx={{ fontWeight: 700 }}>Bienvenido al Dashboard</Typography>
        <Typography variant="body2" color="text.secondary">
          Resumen de atenciones (por defecto: últimos 7 días).
        </Typography>
      </Box>

      <Paper sx={{ p: 2, mb: 2, borderRadius: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3}>
            <TextField label="Desde" type="date" value={desde} onChange={(e)=>setDesde(e.target.value)} fullWidth InputLabelProps={{shrink:true}}/>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField label="Hasta (exclusivo)" type="date" value={hasta} onChange={(e)=>setHasta(e.target.value)} fullWidth InputLabelProps={{shrink:true}}
              helperText="Mañana para cerrar el día de hoy" />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField label="Renaes (opcional)" value={renaes} onChange={(e)=>setRenaes(e.target.value)} fullWidth placeholder="000002026"/>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField label="Id_Ups (opcional)" value={idUps} onChange={(e)=>setIdUps(e.target.value)} fullWidth placeholder="303713"/>
          </Grid>
        </Grid>
      </Paper>

      <DashboardQuick
        desde={desde}
        hasta={hasta}
        renaes={renaes || undefined}
        idUps={idUps || undefined}
      />
    </Container>
  );
}
